export {
  BugReportCaptureProvider,
  NavigationHistoryProvider,
  useNavigationHistory,
  ApiRequestCaptureProvider,
  useApiRequestCapture,
  ConsoleLogCaptureProvider,
  useConsoleLogCapture,
} from './providers';
export type {
  NavigationEntry,
  ApiRequestEntry,
  ConsoleEntry,
} from './types';
export { registerFetchInterceptor } from './interceptors/fetch-interceptor';
